import { createActionGroup, props } from "@ngrx/store";
import { Brand } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataBrandsActions = createActionGroup({
    source: "Data / Brands",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ brands: Brand[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
